export default {
    membership_management: {
        no_membership_number: 'Effectuez votre premier investissement pour devenir membre.',
        membership_number: 'Numéro de membre',
        download_document: 'Télécharger le document d`adhésion',
        send_document: 'Recevoir le formulaire par courrier',
        send_document_requested: 'Envoi du document demandé',
        send_document_sent: 'Le document a été envoyé',
        document_label: 'Document d`adhésion',
        // prettier-ignore
        order_certificates: 'Certificat d\'investissement',
    },
    account_dropdown_log_out: 'Déconnexion',
    account_dropdown_company_account: 'Compte entreprise',
    account_dropdown_tooltip_account: 'Compte investisseur',
    account_dropdown_tooltip_fill_account_data: 'Veuillez compléter vos données d`investisseur',
    account_dropdown_tooltip_orders: 'Investissements',
    account_dropdown_tooltip_wallets: 'Portefeuille',
    personal_account: 'Aperçu du compte',
    welcome: 'Bienvenue',
    header_new_investor: 'Nouvel investisseur ?',
    header_register: 'S`inscrire',
    header_sign_in: 'Se connecter',
    header_unfinished_investment_process: 'Vous avez une commande en cours',
    email_verification_already_verified: 'Votre adresse e-mail a déjà été vérifiée',
    email_verification_email_pending_missmatch:
        'L`adresse e-mail n`a pas pu être vérifiée. Une autre vérification par e-mail a été lancée entre-temps. Veuillez réessayer.',
    email_verification_expired_link: 'Le lien de confirmation a expiré.',
    email_verification_verified: 'Votre adresse e-mail a été modifiée avec succès !',
    create_company_profile_question: 'Souhaitez-vous créer un compte entreprise pour votre compte ?',
    create_company_profile: 'Créer un compte entreprise',
    language_switcher_select_language: 'Sélectionner la langue',
    discard: 'Annuler',
    header: {
        sign_in: 'Se connecter',
        register: 'S`inscrire',
        new_to_invest: 'Nouvel investisseur ?',
    },
    kyc_provider: {
        idnow: 'IDNow',
        signteq: 'Signteq',
    },
    pay_via_eth: 'Payer via ETH',
    gas_limit: 'Prix du gaz',
    address_to_send_eth: 'Adresse du destinataire pour ETH',
    pay_via_eth_desc:
        'Paiement par ETH : Si vous utilisez le virement bancaire comme option de paiement, des frais supplémentaires s`appliqueront en fonction de votre montant d`investissement total. Frais supplémentaires pour le virement de votre investissement.',
    portfolio_size: 'Taille du portefeuille',
    view_details: 'Voir les détails',
    date: 'Date',
    time: 'Heure',
    total: 'Total',
    investment: 'Investissement',
    investment_amount: 'Montant de l`investissement',
    support_amount: 'Montant du soutien',
    order_status_canceled: 'Annulé',
    order_status_pending: 'En attente',
    order_status_paid: 'Payé',
    order_status_approved: 'Approuvé',
    order_status_covered: 'Couvert',
    order_status_accepted: 'Accepté',
    my_orders_side: 'Mes investissements',
    no_order: 'Aucun investissement',
    order_voucher_amount: 'Montant du bon',
    order_discount_voucher_amount: 'Montant du code promo',
    order_wallet_amount: 'Montant du portefeuille',
    success: '',
    error: '',
    copy: '',
    save: 'Enregistrer',
    cancel: 'Annuler',
    copy_to_clipboard: '',
    copied_to_clipboard: '',
    errors: {
        validation_error: '',
        general_error: '',
        // prettier-ignore
        kyc_id_required: 'Le KYC est requis pour procéder à l\'investissement',
        // prettier-ignore
        bank_account_required: 'Un compte bancaire est requis pour poursuivre l\'investissement',
        // prettier-ignore
        kyc_address_required: 'La vérification de l\'adresse est requise pour poursuivre l\'investissement',
        // prettier-ignore
        kyc_tax_required: 'La vérification fiscale est requise pour poursuivre l\'investissement',
    },
    terms_link: '',
    privacy_link: '',
    admin_email: '',
    contact_support: '',
    investment_process: {
        cancel: 'Annuler',
        close: 'Fermer',
        pay_now: 'Payer maintenant',
        // prettier-ignore
        payment_processing:
            'Votre paiement est en cours de traitement. Suivez les instructions qui s\'affichent dans la fenêtre du prestataire de paiement. Veuillez ne pas fermer cette page',
        payment_successful: 'Paiement réussi.',
        payment_failed: 'Paiement échoué. ',
        try_again: 'Réessayer',
        prepaid_payment_successful:
            'Votre paiement est en cours de traitement. Le statut de votre investissement sera mis à jour une fois le paiement reçu.',
        accept_savings_plan: 'Plan d`épargne',
        accept_gift_membership: 'Adhésion cadeau',
        visit_faq_url: 'Pour plus d`informations, cliquez ici',
        emission_agio_text: '',
        emission_disagio_text: '',
        sign_digitally: '',
        show_document: 'Afficher le document',
        signature: 'Signature',
        confirm_signature: 'Finaliser la signature',
        reset_verification_header: 'Nous devons réinitialiser votre vérification',
        // prettier-ignore
        reset_verification_body:
            'Comme vous vous êtes encore vérifié via notre ancien partenaire IDnow, une nouvelle vérification via Signteq est nécessaire avant de pouvoir investir.<br><br>' +
            'Veuillez contacter par e-mail <a href="mailto:support{\'@\'}conda-capital.com">support{\'@\'}conda-capital.com</a> pour demander la réinitialisation du processus de vérification.',
        signature_legal_notice: '',
        signature_legal_notice_title: '',
        nyala_vault: '',
        or: '',
        download_signature_document: '',
        signature_document: 'Document de signature',
        law_requirements: '',
        summary: '',
        payment: '',
        contract_period: '',
        issuer: 'Émetteur',
        minimum_investment: '',
        steps: '',
        next: '',
        back: '',
        time_left: '',
        to_the_landing_page: '',
        thank_you_for_you_investment: '',
        pay_via_bank_transfer_header: '',
        pay_via_bank_transfer_description: '',
        go_to_my_orders: '',
        please_accept_all_documents: '',
        please_accept_all_disclaimers: '',
        please_accept_all_warnings: '',
        wallet_retrievable_balance: 'Montant disponible sur le portefeuille',
        voucher_available_balance: 'Montant disponible sur le bon',
        update_wallet_amount: 'Ajuster le solde du portefeuille',
        apply_wallet_amount: 'Activer le solde du portefeuille',
        update_voucher_amount: 'Ajuster le solde du bon',
        apply_voucher_amount: 'Activer le solde du bon',
        discount_code_applied_successfully: 'Code promo activé avec succès',
        discount_code_higher_than_amount:
            'Le code promo ne peut pas être appliqué car la remise est supérieure au montant restant.',
        available: 'disponible',
        discount_code: 'Code promo',
        apply_discount_button: 'Activer',
        activate_balance: '',
        public_name_consent: '',
        disclaimers: '',
        understand_all_risks: '',
        contract_documents: '',
        accept_all_documents: '',
        accept_all_warnings: '',
        investment_warnings: '',
        investment_warnings_description: '',
        pre_contractual_cooling_off_period: '',
        pre_contractual_cooling_off_period_description: '',
        incentives: '',
        incentive: '',
        selected_incentive: '',
        select_incentive: '',
        which_contract_type: '',
        voucher_title: '',
        voucher_description: '',
        cash_title: '',
        cash_description: '',
        enter_investment_amount: '',
        min_amount: '',
        max_amount: '',
        step_level: '',
        invest: '',
        depot_additional_fields: 'Informations sur votre compte-titres',
        depot_owner: 'Titulaire du compte',
        depot_number: 'Numéro de compte',
        depot_bank: 'Nom de la banque',
        depot_bic: 'BIC ou code bancaire',
        enter_investment_pieces: '',
        emission_pieces_to_amount: '',
        emission_amount_to_pieces: '',
        investment_summary: '',
        investment_amount: '',
        wallet_amount: '',
        wallet_amount_description:
            'Veuillez sélectionner le montant que vous souhaitez couvrir avec votre solde de portefeuille existant',
        voucher_amount: '',
        voucher_amount_description: 'Veuillez sélectionner le bon souhaité et le montant que vous souhaitez activer.',
        expires_at: 'Expire le',
        contract_type: '',
        amount_to_pay: '',
        registration_number: '',
        address: '',
        invest_as_natural_profile: '',
        invest_as_legal_profile: '',
        invest_in: '',
        create_order: '',
        payment_account_holder_default: '',
        pay_via_credit_card_header: '',
        pay_via_credit_card_description: '',
        pay_via_credit_card_button: '',
        verification_outstanding: '',
        verification_outstanding_description: '',
        verify_button: '',
        broker: '',
        broker_id: '',
        please_provide_broker_id: '',
        please_confirm: '',
        please_confirm_your_details: '',
        please_fill_required_fields: '',
        note: 'note',
        email_must_match_profile:
            'L`adresse e-mail que vous avez saisie ne correspond pas à votre adresse e-mail de profil.',
        first_name_must_match_profile: 'Le prénom que vous avez saisi ne correspond pas à votre prénom de profil.',
        last_name_must_match_profile: 'Le nom que vous avez saisi ne correspond pas à votre nom de profil.',
        ecsp: {
            not_enough_experience_title: '',
            not_enough_experience_description: '',
            not_enough_risk_acknowledgements_title: '',
            not_enough_risk_acknowledgements_description: '',
            investment_too_high_title: '',
            investment_too_high_description: '',
        },
        altfg: {
            investment_process_altfg_notice: '',
            investment_process_altfg_choice_notice: '',
            investment_process_altfg_professional_investor: '',
            investment_process_altfg_legal_entity: '',
            investment_process_altfg_maximum_net_income: '',
            investment_process_altfg_maximum_assets: '',
        },
        vermanlg: {
            vib_investor_from_germany: '',
            investments_information_sheet: '',
            vib_current_location: '',
            vib_date: '',
            vib_email: '',
            vib_first_name: '',
            vib_last_name: '',
            vib_place_of_birth: '',
            vib_date_of_birth: '',
            vib_id_card_passport_number: '',
            issuing_authority: '',
            vib_address: '',
            vib_postal_code: '',
            vib_city: '',
            vib_state: '',
            vib_tax_number: '',
            vib_investment_information: '',
            vib_investment_under_1000: '',
            vib_investment_financial_assets_over_10000: '',
            vib_investment_income_over_1k: '',
            vib_investment_income_over_10k: '',
            vib_investment_limit_part_1: '',
            vib_investment_limit_part_2: '',
            vermanlg_confirm_section_note: '',
            vermanlg_right_of_withdrawal: '',
            vermanlg_right_of_withdrawal_disclaimer: '',
            vermanlg_consequences_of_revocation: '',
            vermanlg_consequences_of_revocation_disclaimer: '',
        },
        stock_price: 'Prix de la part',
        stock: 'Parts',
        agio: 'Agio',
        disagio: 'Disagio',
        per_share: 'par action',
        pre_emptive_rights_notice_title: 'Droits de préemption requis',
        pre_emptive_rights_notice_body:
            'Un investissement dans cette campagne nécessite des droits de préemption. Vous détenez actuellement :',
        pre_emptive_rights_units: 'droit(s)',
    },
    forms: {
        select_option: '',
        radio_no: '',
        radio_yes: '',
        radio_male: '',
        radio_female: '',
        day: '',
        month: '',
        year: '',
        dd: '',
        mm: '',
        yyyy: '',
    },
    account: {
        investor_account: '',
        my_profile: '',
        first_name: '',
        last_name: '',
        save: '',
        date_of_birth: '',
        nationality: '',
        address: '',
        postal_code: '',
        city: '',
        same_as_residential: '',
        country_of_birth: '',
        city_of_birth: '',
        // prettier-ignore
        esac_locked_account_info:
            'Pour modifier ou mettre à jour les informations et documents de profil ou KYC, veuillez contacter l\'équipe ESAC par e-mail via platform{\'@\'}superangels.club',
        phone_number: '',
        iban: '',
        bic: '',
        social_security_number: '',
        tax_number: '',
        mobile_number: '',
        current_email: '',
        email_pending: '',
        new_email: '',
        email_address: '',
        country: '',
        state: '',
        gender: '',
        gender_placeholder: '',
        pep: '',
        pep_past: '',
        pep_position: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        saved_kyc_successfully_message: '',
        average_investment_transaction_amount: '',
        average_investment_transactions_per_year: '',
        investment_transactions: '',

        experience_share: '',
        experience_bond: '',
        experience_participation_paper: '',
        experience_crypto_currency: '',
        experience_unsecured_junior_debt: '',
        knowledge_share: '',
        knowledge_bond: '',
        knowledge_participation_paper: '',
        knowledge_crypto_currency: '',
        knowledge_unsecured_junior_debt: '',

        experience_with_securities: '',
        experience_without_advice: '',
        experience_with_asset_management: '',
        experience_with_investment_advice: '',

        bonds: '',
        stocks: '',
        market_funds: '',
        investment_funds: '',
        experience_investment_forms: '',
        current_occupation: '',
        highest_educational_attainment: '',
        default_language: 'Langue par défaut',
    },
    portfolio: {
        investments_total: '',
        open_investments: '',
        my_investments: '',
        secondary_market_pre_emptive_rights_title: 'Marché secondaire - Mes droits de souscription',
        rights_unit: 'Droits de souscription',
        unit_short: 'pcs.',
        no_investments_to_show: '',
        orders: {
            order_status: '',
            order_status_active: '',
            order_status_completed: '',
            order_status_canceled: '',
            order_status_pending: '',
            order_status_paid: '',
            order_status_approved: '',
            order_status_covered: '',
            order_status_accepted: '',
        },
    },
    investment_targets: {
        investment_objectives: 'Vos objectifs d`investissement',
        // prettier-ignore
        legal_investment_objectives: 'Objectifs d`investissement de l`entité',
        security_coverage: 'Plan de retraite',
        security_coverage_or_pension_plan: 'Couverture de sécurité du paiement de départ ou du plan de retraite',
        pension_provision: 'Provision de retraite',
        retention_of_assets: 'Conservation des actifs',
        distribution_of_assets: 'Distribution des actifs',
        capital_gain: 'Plus-value',
        investment_horizon: 'Votre horizon d`investissement',
        // prettier-ignore
        legal_investment_horizon: 'Horizon d\'investissement de l\'entité',
        investment_frequency:
            'Fréquence de vos investissements dans des actifs alternatifs (y compris le capital-risque et le private equity)',
        // prettier-ignore
        legal_investment_frequency:
            'Fréquence des investissements de l\'entité dans des actifs alternatifs (y compris le capital-risque et le private equity) :',
    },
    financial_conditions: {
        financial_assets: 'Actifs financiers (en EUR)',
        annual_operating_result: 'Revenu annuel (en EUR)',
        dept_capital: 'Capital d`endettement (en EUR)',
        properties: 'Propriété immobilière',
        source_of_funds: 'Source des fonds (c`est l`origine des fonds spécifiques que vous allez investir)',
        dividends_or_profits: 'Dividendes ou bénéfices des investissements',
        lottery_gambling: 'Loterie/jeux d`argent',
        divorce: 'Divorce',
        maturity_or_surrender: 'Échéance ou rachat d`une police d`assurance-vie',
        gift: 'Cadeau',
        inheritance: 'Héritage',
        insurance_claims: 'Réclamations d`assurance',
        sale_of_property: 'Vente de propriété',
        savings: 'Épargne',
        loan: 'Prêt',
        other: 'Autre',
        industry: 'Secteur de votre activité principale et/ou de votre profession :',
        // prettier-ignore
        business_industry: 'Secteur de l\'activité principale de l\'entité :',
        dividends_or_profits_legal: 'Dividendes ou bénéfices des participations/investissements/actifs',
        retained_earnings: 'Bénéfices non distribués',
    },
    fatca_declaration: {
        cannot_continue: 'Malheureusement, vous ne pouvez pas compléter le processus KYC en ligne.',
        financial_institutions_under_fatca:
            'Classification FATCA de l`entreprise : L`entité est-elle une institution financière (IF) au sens de la FATCA ?',
        // prettier-ignore
        contact_support: 'Veuillez contacter Venionaire à platform{\'@\'}superangels.club.',
        us_citizen_or_resident: 'Êtes-vous un citoyen américain et/ou résident aux États-Unis à des fins fiscales ?',
        non_financial_entity_reason:
            'Veuillez sélectionner l`une des catégories suivantes pour déterminer le type d`ENE auquel appartient l`investisseur (Entité juridique)',
        financial_institution_category:
            'Institutions financières au sens de la FATCA : Veuillez sélectionner l`une des catégories suivantes :',
        us_entity: 'L`entité est-elle une Personne américaine au sens des réglementations FATCA ?',
        provide_giin: 'Pouvez-vous fournir le GIIN du titulaire du registre obtenu aux fins de la FATCA',
        no_giin_reason:
            'Si l`entreprise est une institution financière mais ne peut pas émettre de GIIN, veuillez cocher l`une des raisons suivantes :',
        giin: 'Veuillez fournir le GIIN de l`Entité obtenu aux fins de la FATCA :',
        giin_sponsor_name: 'Nom du parrain',
        giin_sponsor: 'GIIN du parrain',
    },
    crs_classification: {
        company_classification: 'Classification CRS de l`entreprise :',
        stock_exchange_name:
            'Veuillez fournir le nom de la bourse établie où les actions de l`entreprise sont régulièrement négociées :',
        affiliate_stock_exchange_name:
            'Ou si vous êtes une filiale d`une entreprise régulièrement négociée sur une bourse établie, veuillez fournir le nom de la bourse établie et de cette entreprise :',
    },
    country_tax_residencies: {
        add_another_tax_residence: 'Ajouter une autre résidence fiscale',
        cant_obtain_tin: 'Je ne peux pas obtenir un numéro d`identification fiscale',
        tax_situation: 'Votre situation fiscale',
        tax_residency: 'Résidence fiscale',
        capital_gains: 'Exonération de l`impôt sur les plus-values (KESt)',
        foreign_assets_ownership: 'Propriété d`actifs étrangers',
        foreign_assets: 'Actifs étrangers',
        capital_gains_legal: 'Exonération de l`impôt sur les plus-values (KESt)',
        corporate_tax_exemption: 'Exonération de l`impôt sur les sociétés (KÖSt)',
        group_taxation: 'Imposition de groupe',
    },
    legal_acknowledgements: {
        risks_acknowledgement:
            'Je/nous reconnaissons que Venionaire Ventures S.à r.l. ("VV") n`acceptera pas une demande d`achat d`unités de fonds si aucune information n`est fournie sur la disposition au risque. De plus, je/nous reconnaissons que, outre les risques énumérés, des fluctuations de valeur peuvent survenir en raison de changements de devise (y compris l`inflation).',
        // prettier-ignore
        anti_money_laundering:
            'Conformément à la loi modifiée sur la lutte contre le blanchiment d\'argent et le financement du terrorisme du 12 novembre 2004, je/nous déclarons que le(s) BDU divulgué(s) est/sont le(s) bénéficiaire(s) effectif(s) de l\'Investisseur et nous nous engageons à informer l\'auditeur de VV de tout changement dans la participation, les droits de vote ou le(s) bénéficiaire(s) effectif(s) de l\'Investisseur. Je/nous déclarons également que l\'origine des fonds et des titres utilisés pour effectuer les opérations de l\'Investisseur ne contrevient pas à cette loi. Je/nous déclarons enfin que l\'utilisation prévue des actifs découlant de ces opérations ne contrevient pas non plus à cette loi.',
        authorised_signatory:
            'Je/nous certifie/certifions que je/nous suis/sommes le(s) signataire(s) autorisé(s) de l`Investisseur et reconnaît/reconnaissons que, conformément à l`article 5 de la loi luxembourgeoise CRS, il est obligatoire de répondre aux questions relatives aux informations divulguées concernant l`auto-certification fiscale.',
        tax_authorities:
            'En particulier, je/nous reconnaît/reconnaissons et accepte/acceptons que les informations divulguées peuvent être communiquées aux autorités fiscales du Luxembourg ou à d`autres délégués autorisés en vertu de la loi luxembourgeoise conformément aux informations requises concernant les comptes financiers (voir l`Annexe I, Section I de la loi "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", ci-après "Loi luxembourgeoise CRS") concernant l`Investisseur ou son/ses bénéficiaire(s) effectif(s) et tout registre déclarable. De plus, je/nous reconnaît/reconnaissons et accepte/acceptons que les informations divulguées peuvent être échangées avec les autorités fiscales du/des pays dans le(s)quel(s) je/nous et/ou l`Investisseur a/avons établi une résidence fiscale conformément aux accords d`échange de données fiscales intergouvernementaux.',
        intergovernmental_tax_exchange:
            'Je/nous autorise/autorisons VV à transmettre/échanger toutes les informations divulguées, ainsi que les informations nécessaires aux déclarations en vertu des accords d`échange de données fiscales intergouvernementaux, comme décrit ci-dessus, avec les autorités fiscales compétentes du ou des pays.',
        notify_about_changes:
            'Je/nous nous engageons à informer VV dans les 30 jours de tout changement affectant l`auto-certification et de tout changement affectant les informations fournies et à fournir à VV une auto-certification mise à jour correspondante sans délai et sans demande. J`aurai/nous aurons accès, sur demande, aux données me/nous concernant/l`Investisseur/le(s) BDU qui seront communiquées aux autorités fiscales luxembourgeoises et pourrai/pourrons rectifier les données personnelles. Les données collectées ne seront pas conservées plus longtemps que nécessaire aux fins de la loi luxembourgeoise CRS.',
        information_correct_and_complete:
            'Je/nous déclare/déclarons que toutes les informations fournies par moi/nous sont correctes et complètes à ma/notre connaissance et à ma/notre conviction.',
    },
    acknowledgements: {
        check_all: 'Tout cocher',
        currency_change_risk:
            'Je/nous reconnaissons que Venionaire Ventures S.à r.l. ("VV") n`acceptera pas une demande d`achat d`unités de fonds si aucune information n`est fournie sur la disposition au risque. De plus, je/nous reconnaissons que, outre les risques énumérés, des fluctuations de valeur peuvent survenir en raison de changements de devise (y compris l`inflation).',
        own_account:
            'Je/nous certifie/certifions que je/nous suis/sommes le(s) signataire(s) autorisé(s) de l`Investisseur et reconnaît/reconnaissons que, conformément à l`article 5 de la loi luxembourgeoise CRS, il est obligatoire de répondre aux questions relatives aux informations divulguées concernant l`auto-certification fiscale.',
        // prettier-ignore
        anti_money_laundering:
            'Conformément à la loi modifiée sur la lutte contre le blanchiment d\'argent et le financement du terrorisme du 12 novembre 2004, je/nous déclarons que le(s) BDU divulgué(s) est/sont le(s) bénéficiaire(s) effectif(s) de l\'Investisseur et nous nous engageons à informer l\'auditeur de VV de tout changement dans la participation, les droits de vote ou le(s) bénéficiaire(s) effectif(s) de l\'Investisseur. Je/nous déclarons également que l\'origine des fonds et des titres utilisés pour effectuer les opérations de l\'Investisseur ne contrevient pas à cette loi. Je/nous déclarons enfin que l\'utilisation prévue des actifs découlant de ces opérations ne contrevient pas non plus à cette loi.',
        self_certification_form:
            'En particulier, je/nous reconnaît/reconnaissons et accepte/acceptons que les informations divulguées peuvent être communiquées aux autorités fiscales du Luxembourg ou à d`autres délégués autorisés en vertu de la loi luxembourgeoise conformément aux informations requises concernant les comptes financiers (voir l`Annexe I, Section I de la loi "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", ci-après "Loi luxembourgeoise CRS") concernant l`Investisseur ou son/ses bénéficiaire(s) effectif(s) et tout registre déclarable. De plus, je/nous reconnaît/reconnaissons et accepte/acceptons que les informations divulguées peuvent être échangées avec les autorités fiscales du/des pays dans le(s)quel(s) je/nous et/ou l`Investisseur a/avons établi une résidence fiscale conformément aux accords d`échange de données fiscales intergouvernementaux.',
        tax_data_exchange_agreement:
            'Je/nous autorise/autorisons VV à transmettre/échanger toutes les informations divulguées, ainsi que les informations nécessaires aux déclarations en vertu des accords d`échange de données fiscales intergouvernementaux, comme décrit ci-dessus, avec les autorités fiscales compétentes du ou des pays.',
        report_changes:
            'Je/nous nous engageons à informer VV dans les 30 jours de tout changement affectant l`auto-certification et de tout changement affectant les informations fournies et à fournir à VV une auto-certification mise à jour correspondante sans délai et sans demande. J`aurai/nous aurons accès, sur demande, aux données me/nous concernant/l`Investisseur/le(s) BDU qui seront communiquées aux autorités fiscales luxembourgeoises et pourrai/pourrons rectifier les données personnelles. Les données collectées ne seront pas conservées plus longtemps que nécessaire aux fins de la loi luxembourgeoise CRS.',
        complete_and_correct_information:
            'Je/nous déclare/déclarons que toutes les informations fournies par moi/nous sont correctes et complètes à ma/notre connaissance et à ma/notre conviction.',
    },
    experience_and_knowledge: {
        experience: 'Expérience d`investissement',
        knowledge: 'Connaissance',
        stocks_equity_funds: 'Actions, fonds actions',
        mixed_funds_etfs: 'Fonds mixtes, ETF',
        bonds_bond_funds: 'Obligations, fonds obligataires',
        closed_ended_funds: 'Fonds à capital fixe',
        options_other_derivatives: 'Options, autres dérivés',
        venture_capital: 'Capital-risque',
        other_shares_loans_in_private_companies: 'Autres actions/prêts dans des entreprises privées',
        other_alternative_investments:
            'Autres investissements alternatifs (fonds spéculatifs, fonds de matières premières, etc.)',
        follow_market_prices_business_financial_news:
            'À quelle fréquence consultez-vous les prix du marché, les nouvelles économiques et financières ?',
    },
    follow_market_options: {
        regularly: 'régulièrement',
        occasionally: 'occasionnellement',
        rarely: 'rarement',
        not_at_all: 'jamais',
    },
    investment_knowledge: {
        advanced: 'avancé',
        basic: 'basique',
        none: 'aucune',
    },
    investment_horizon: {
        short_term: 'court terme (< 5 ans)',
        medium_term: 'moyen terme (5-10 ans)',
        long_term: 'long terme (11-20 ans)',
        very_long_term: 'très long terme (> 20 ans)',
    },
    investment_frequency: {
        one_off: 'ponctuel',
        monthly: 'mensuel',
        quarterly: 'trimestriel',
        semi_annually: 'semestriel',
        annually: 'annuel',
    },
    risk_tolerance: {
        label: 'Votre tolérance au risque est :',
        // prettier-ignore
        label_legal: 'Tolérance au risque de l\'investisseur (Entité juridique) :',
        low: 'Faible',
        medium: 'Moyenne',
        advanced: 'Avancée',
        high: 'Élevée',
    },
    verification: {
        pdf_both_sides: 'PDF (avec les deux côtés)',
        upload_id_pdf: 'Cliquez ici pour télécharger le fichier (PDF)',
        upload_id_image: 'Cliquez ici pour télécharger le fichier (JPG, PNG, JPEG)',
        identity_verification: 'Vérification d`identité',
        identity_verification_subheadline: 'Sous-titre de vérification d`identité',
        identity_verification_upload_notice: 'Avis de téléchargement de vérification d`identité',
        tax_verification: 'Vérification fiscale',
        bank_verification: 'Vérification bancaire',
        bank_verification_headline: 'Titre de vérification bancaire',
        address_verification: 'Vérification d`adresse',
        address_verification_headline: 'Titre de vérification d`adresse',
        address_verification_subheadline: 'Sous-titre de vérification d`adresse',
        legal_verification: 'Vérification légale',
        legal_verification_subheadline: 'Sous-titre de vérification légale',
        legal_bank_verification: 'Vérification bancaire légale',
        legal_bank_verification_subheadline: 'Sous-titre de vérification bancaire légale',
        upload_label: 'Étiquette de téléchargement',
        upload_invalid_field: 'Champ de téléchargement invalide',
        upload_waiting_for_size: 'En attente de la taille',
        upload_size_not_available: 'Taille non disponible',
        upload_loading: 'Chargement',
        upload_load_error: 'Erreur de chargement',
        upload_processing: 'Traitement',
        upload_processing_complete: 'Traitement terminé',
        upload_processing_aborted: 'Traitement interrompu',
        upload_processing_error: 'Erreur de traitement',
        upload_processing_revert_error: 'Erreur de retour en arrière du traitement',
        upload_file_remove_error: 'Erreur de suppression du fichier',
        upload_tap_to_cancel: 'Appuyez pour annuler',
        upload_tap_to_retry: 'Appuyez pour réessayer',
        upload_tap_to_undo: 'Appuyez pour annuler',
        upload_button_remove_item: 'Supprimer l`élément',
        upload_button_abort_item_load: 'Interrompre le chargement',
        upload_button_retry_item_load: 'Réessayer le chargement',
        upload_button_abort_item_processing: 'Interrompre le traitement',
        upload_button_undo_item_processing: 'Annuler le traitement',
        upload_button_retry_item_processing: 'Réessayer le traitement',
        upload_button_process_item: 'Traiter l`élément',
        tax_verification_headline: 'Titre de vérification fiscale',
        complete_data: 'Compléter les données',
        complete_data_description: 'Description de complétion des données',
        complete_data_description_for_verification: 'Description de complétion des données pour la vérification',
        complete_data_description_short: 'Description courte de complétion des données',
        complete_verification_outstanding: 'Vérification incomplète',
        complete_verification_complete: 'Vérification complète',
        completed_data: 'Données complétées',
        completed_data_description: 'Description des données complétées',
        complete_data_action_button: 'Bouton d`action de complétion des données',
        kyc_process: 'Processus KYC',
        kyc_process_description: 'Description du processus KYC',
        kyc_process_action_button: 'Bouton d`action du processus KYC',
        old_value: 'Ancienne valeur',
        no_changes: 'Toutes les données correspondent aux informations précédemment fournies.',
        save: 'Enregistrer',
        depot: 'Compte-titres',
        depot_verification_subheadline:
            'Veuillez indiquer ici les informations nécessaires concernant votre compte-titres.',
        new_value: 'Nouvelle valeur',
        override_data: 'Remplacer les données',
        override_data_description: 'Description de remplacement des données',
        verification_successful: 'Vérification réussie',
        verification_successful_description: 'Description de la vérification réussie',
        status_not_started: 'Statut non commencé',
        status_not_started_description: 'Description du statut non commencé',
        status_created: 'Statut créé',
        status_created_description: 'Description du statut créé',
        status_in_review: 'Statut en cours d`examen',
        status_in_review_description: 'Description du statut en cours d`examen',
        status_data_changed: 'Statut des données modifié',
        status_data_changed_description: 'Description du statut des données modifiées',
        status_success: 'Statut succès',
        status_success_description: 'Description du statut succès',
        status_failure: 'Statut échec',
        // prettier-ignore
        status_user_canceled: 'Annulé par l\'utilisateur',
        status_user_canceled_loading_description: 'Le chargement a pris trop de temps',
        status_user_canceled_unavailable_description: 'Je ne dispose pas des documents / informations requis',
        // prettier-ignore
        status_user_canceled_privacy_description: 'J\'ai des préoccupations concernant la confidentialité',
        status_user_canceled_unclear_description: 'Je ne suis pas sûr de ce que je dois faire',
        status_user_canceled_technical_description: 'Problèmes techniques',
        status_user_canceled_other_description: 'Aucun des éléments ci-dessus',
        status_user_canceled_unknown_description: 'Raison inconnue',
        status_failure_description: 'Description du statut échec',
        id_now_kyc_continue_button: 'Bouton continuer KYC IDNow',
        id_now_kyc_waiting_for_id_now_button: 'Bouton d`attente IDNow KYC',
        id_now_kyc_restart_button: 'Bouton redémarrer KYC IDNow',
        id_now_kyc_start_button: 'Bouton démarrer KYC IDNow',
        ecsp_status_rejected: 'Non qualifié - rejeté',
        ecsp_status_pending: 'Non qualifié - vérification en attente',
        ecsp_status_expert: 'Qualifié',
        ecsp_status_non_expert: 'Non qualifié',
        signteq_kyc_start_button: 'Démarrer la vérification KYC',
        signteq_kyc_restart_button: 'Redémarrer le processus KYC',
    },
    camera: {
        click_here_to_capture_image: 'Cliquez ici pour prendre une photo',
        close: 'Fermer la caméra',
        or: 'ou',
    },
    id_front: 'Recto',
    id_back: 'Verso',
    newsletter_verification_success: 'Votre abonnement à la newsletter a été confirmé avec succès !',
    membership_document: {
        status: {
            accepted: 'Accepté',
            pending: 'En attente',
            rejected: 'Rejeté',
        },
    },
    ecsp: {
        natural: {
            info_text: '',
            info_text_highlight_one: '',
            info_text_highlight_two: '',
            info_text_highlight_three: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            experience: {
                no_answer: '',
                financial_education: '',
                bonds_knowledge: '',
                bonds_investment_frequency: '',
                stocks_knowledge: '',
                stocks_investment_frequency: '',
                convertible_bonds_knowledge: '',
                convertible_bonds_investment_frequency: '',
            },
            risk: {
                no_answer: '',
                startup_investing: '',
                investments_outside_stock_market: '',
                subordinated_financial_instruments: '',
                profit_participation_certificate: '',
            },
        },
        legal: {
            info_text: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            risk: {
                most_startups: '',
                dividends: '',
                higher_interest_rates: '',
                secure_investment: '',
                stocks_bankrupt_company: '',
                good_long_term_investment: '',
                return_on_investment: '',
            },
        },
        investment_frequency: {
            less_than_5_times: '',
            more_than_5_times: '',
            no_answer: '',
        },
        investment_horizon: {
            two_years: '',
            up_to_5_years: '',
            more_than_5_years: '',
            no_answer: '',
        },
        startup_investing: {
            high_return_low_risk: '',
            loss: '',
            growth: '',
        },
        investments_outside_stock_market: {
            low_risk: '',
            high_risk: '',
            high_proportion: '',
        },
        subordinated_financial_instruments: {
            insolvency_quote: '',
            equal_with_other_creditors: '',
            lose_investment: '',
        },
        profit_participation_certificate: {
            participate_profits_losses: '',
            fixed_interest_amount: '',
            transfer_to_company: '',
        },
        investor_classification: {
            expert_investor_treatment: '',
            self_disclosure_explanation: '',
            self_disclosure: '',
            print: '',
            upload_self_disclosure: '',
        },
        financial_education: {
            professional_experience: '',
            relevant_degree: '',
            both: '',
            none: '',
        },
        investment_goals: {
            no_answer: '',
            sustainability: '',
            investment_goal: '',
            investment_horizon: '',
        },
        sustainability: {
            very_true: '',
            applies: '',
            does_not_apply: '',
            no_answer: '',
        },
        investment_goal: {
            wealth_building: '',
            speculative_investments: '',
            no_answer: '',
        },
        most_startups: {
            successful: '',
            fail: '',
        },
        dividends: {
            equity: '',
            debt_capital: '',
        },
        higher_interest_rates: {
            secure_investment: '',
            risk_investment: '',
        },
        secure_investment: {
            bond_brd: '',
            bond_us_treasury: '',
            vw_share: '',
        },
        stocks_bankrupt_company: {
            refund: '',
            loss: '',
        },
        good_long_term_investment: {
            company_investment_portfolio: '',
            scatter_investments: '',
        },
        return_on_investment: {
            less_than_5_years: '',
            more_than_5_years: '',
        },
        financial_situation: {
            calculate: '',
            no_value: 'N/A',
            net_worth: '',
            net_worth_tooltip: '',
            loss_bearing_capacity: '',
            loss_bearing_capacity_tooltip: '',
            annual_net_income: '',
            annual_net_income_tooltip: '',
            annual_financial_commitments: '',
            annual_financial_commitments_tooltip: '',
            calculation_of_net_worth: '',
            liquid_funds: '',
            liquid_funds_tooltip: '',
            info_text: '',
        },
    },
    legal_account: {
        company_profile: '',
        company_name: '',
        registration_number: '',
        legal_form: 'Legal Form',
        registration_authority: 'Registration Authority',
        address: '',
        description: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        iban: '',
        bic: '',
        tax_number: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        investor_classification: '',
        risk: '',
        financial_situation: '',
        default_language: 'Default language',
    },
    beneficial_owner: {
        country_of_birth: '',
        city_of_birth: '',
        country_of_residence: '',
        no_beneficial_owners: '',
        no_beneficial_owners_description: '',
        indirect_ownership: 'Please indicate the respective company name in case of indirect ownership',
        remove: 'Remove',
    },
    highest_educational_attainment: {
        prefer_not_to_say: '',
        no_degree: '',
        secondary_school: '',
        junior_high_school: '',
        high_school_diploma: '',
        university: '',
    },
    investment_experience: {
        none: '',
        up_to_3_years: '',
        between_3_and_5_years: '',
        more_than_5_years: '',
    },
    average_investment_transaction: {
        none: '',
        up_to_5: '',
        between_5_and_10: '',
        over_10: '',
    },
    average_investment_amount: {
        up_to_3000_eur: '',
        between_3001_and_5000_eur: '',
        between_5001_and_10000_eur: '',
        over_10000_eur: '',
    },
    validation_error: {
        required: '',
        email: '',
        invalid: '',
        countryISO3166: '',
        iban: '',
        bic: '',
        new_email_not_equals_old: '',
        wrong_date_format: '',
        date_min: '',
        date_max: '',
        min_age: '',
        max_age: '',
        min_amount: '',
        min_amount_on_wallet: '',
        max_amount: '',
        // prettier-ignore
        duplicate_iban: 'Cet IBAN est déjà enregistré pour l\'un de vos comptes bancaires.',
    },
    account_settings: {
        dashboard: '',
        personal_data: '',
        personal_data_headline: '',
        address_data: '',
        address_data_headline: '',
        address_data_subtitle: '',
        membership_management: 'Gestion des membres',
        nyala_vault: '',
        nyala_vault_headline: '',
        nyala_vault_subtitle: '',
        postal_address_data: 'Votre adresse postale',
        compliance_profile: '',
        compliance_profile_subtitle: '',
        contact_data: '',
        contact_data_headline: '',
        contact_data_subtitle: '',
        security: '',
        security_headline: '',
        security_subtitle: '',
        verification: '',
        verification_headline: '',
        verification_subtitle: '',
        bank_data: '',
        bank_data_headline: '',
        bank_data_subtitle: '',
        tax_residencies: 'Résidences fiscales',
        tax_data: '',
        overview: '',
        profile_data: '',
        legal_information: '',
        edit: '',
        legal_information_subtitle: '',
        current_status: '',
        crypto_wallet: '',
        crypto_wallet_headline: '',
        signatures: '',
        signatures_headline: '',
        signatures_subtitle: '',
        referral_program: '',
        referral_program_headline: '',
        referral_program_notice: '',
        investment_targets: 'Investor Profile',
        investment_targets_subtitle:
            /* eslint-disable-next-line quotes */
            "L'horizon d'investissement représente votre volonté de durée d'investissement de base.",
        financial_conditions: 'Situation financière',
        /* eslint-disable-next-line quotes */
        experience_and_knowledge: "Expérience et connaissance d'investissement",
        risk_tolerance: 'Tolérance au risque',
        fatca_declaration: 'Déclaration FATCA',
        acknowledgements: 'Acknowledgements',
        kyc_form: 'Formulaire KYC',
        tax_situation: 'Situation fiscale',
        investor_classification: '',
        experience: '',
        risk: '',
        investment_goals: '',
        financial_situation: '',
    },
    compliance_profile: {
        save_header: '',
        save_description: '',
        discard_header: '',
        discard_description: '',
        save_financial_data_header: '',
        save_financial_data_description: '',
        back_to_compliance_profile: '',
        status: 'Status: {status}',
        compliance_profile_complete_and_valid_description: 'Your compliance profile is complete and valid.',
        compliance_profile_complete_and_invalid_description: 'Your compliance profile is complete but invalid.',
        compliance_profile_incomplete_description: 'Your compliance profile is incomplete.',
        complete: 'Complete',
        incomplete: 'Incomplete',
        complete_data: 'Complete the compliance profile',
        complete_data_description: 'Please complete the data in your compliance profile to continue.',
        show_document: 'Show Document',
        upload_document: 'Upload new Document',
        edit_data: '',
        discard_data: '',
    },
    signatures: {
        complete_data_description_for_signatures: '',
        complete_compliance_profile: 'Complete the compliance profile',
        sign_document: '',
        sign_documents: '',
        not_signed: '',
        signed: '',
        no_signatures: '',
        no_signatures_description: '',
        pending_signatures: '',
        pending_signatures_description: '',
        show_document: '',
        dialog_close_button: '',
        regenerate_signatures: '',
        regenerate_signatures_notice: '',
        print: '',
    },
    account_settings_legal: {
        dashboard: '',
        company_data: '',
        overview: '',
        address_data: '',
        bank_data: '',
        tax_data: '',
        verification: '',
        verification_kyc_documents_subtitle: '',
        manager_area: '',
        manager_area_subtitle: '',
        beneficial_owners: '',
        beneficial_owners_subtitle: '',
        /* eslint-disable-next-line quotes */
        investment_objectives: "Profil d'investissement de l'entité",
        /* eslint-disable-next-line quotes */
        financial_conditions: "Situation financière de l'entité",
        /* eslint-disable-next-line quotes */
        risk_tolerance: "Tolérance au risque de l'entité",
        tax_situation: 'Informations fiscales',
        crs_classification: 'Classification CRS',
        acknowledgements: 'Reconnaissances',
    },
    legal_account_manager_beneficial_owner: {
        beneficial_owner: 'Beneficial Owner',
        manager: 'Manager',
        postal_address: 'Postal Address',
        no_beneficial_owners: 'No additional beneficial owners added',
    },
    legal_account_beneficial_owners: {
        add_beneficial_owner: '',
        manager: '',
    },
    legal_account_managers: {
        beneficial_owner: '',
        add_manager: '',
        manager_invited_notice: '',
        pending_invitations: '',
        dialogs: {
            failure_title: '',
            failure_message: '',
            failure_button: '',
            success_title: '',
            success_message: '',
            success_button: '',
            registration_required_title: '',
            registration_required_message: '',
            registration_required_button: '',
            already_accepted_title: '',
            already_accepted_message: '',
            already_accepted_button: '',
            legal_account_already_exists_title: '',
            legal_account_already_exists_message: '',
            legal_account_already_exists_button: '',
        },
    },
    account_links: {
        heading: '',
        orders: '',
        wallet: '',
        secondary_market: 'Marché secondaire',
    },
    referral_program: {
        your_referral_link: '',
        your_referral_code: '',
        generate_referral_code: '',
        generate_referral_code_description: '',
        generated_referral_code_successfully_message: '',
        generated_referral_code_error_message: '',
        referral_link_social_media_sharing: '',
        referral_info_title: '',
        referral_info_message: '',
        referral_existing_user_title: '',
        referral_existing_user_message: '',
        referral_campaign_not_found_title: '',
        referral_campaign_not_found_message: '',
        referral_success_custom_event_title: '',
        referral_success_custom_event_message: '',
        referral_success_redemption_event_title: '',
        referral_success_redemption_event_message: '',
    },
    verification_kyc_document: {
        show_details_button: '',
        hide_details_button: '',
        uploaded_at: '',
        comment: '',
        valid_to: '',
        verified_at: '',
        add_new_document: '',
        identification_type: '',
        in_progress: '',
        in_progress_description: '',
        on_hold: '',
        on_hold_description: '',
        accepted: '',
        accepted_description: '',
        accepted_not_eligible_for_withdrawal_description: '',
        accepted_not_eligible_for_withdrawal_description_re_upload: '',
        accepted_not_eligible_for_withdrawal_description_contact_support: '',
        rejected: '',
        rejected_description: '',
        unreadable: '',
        unreadable_description: '',
        expired: '',
        expired_description: '',
        wrong_type: '',
        wrong_type_description: '',
        wrong_name: '',
        wrong_name_description: '',
        duplicate_document: '',
        duplicate_document_description: '',
        type: {
            'passport': '',
            'invoice': '',
            'id-card': '',
            'residence-confirmation': '',
            'bank-statement': '',
            'sdd-mandate': '',
            'company-registration': '',
            'articles-of-association': '',
            'other': '',
        },
    },
    crypto_wallet: {
        request_wallet_button: '',
        notice: '',
        complete_verification_description_for_crypto_wallet: '',
        complete_data_description_for_crypto_wallet: '',
        success_dialog_title: '',
        success_dialog_description: '',
        success_dialog_button: '',
        error_dialog_title: '',
        error_dialog_description: '',
        error_dialog_button: '',
    },
    nyala_vault: {
        pin_info: '',
        reset_pin: '',
        invalid_pin: '',
        enter_a_valid_pin: '',
        reset_initiated_info: '',
        generate_random_pin: '',
        invalid_nyala_pin: '',
        nyala_new_pin: '',
        nyala_confirm_pin: '',
        explorer: '',
        explorer_link: '',
        confirm_pin: '',
        enter_confirm_pin: '',
        pin_confirmed: '',
        nyala_vault_not_created: '',
        vault_not_created_yet_at_nyala: '',
        nyala_passphrase_verification_success_title: '',
        nyala_passphrase_verification_success_message: '',
        nyala_passphrase_verification_expired_link_title: '',
        nyala_passphrase_verification_expired_link_message: '',
        invalid_link: 'Der Link ist nicht mehr gültig!',
    },
    bank_data: {
        iban_from_bank_account_notice: '',
        iban_from_bank_account_link_button: '',
        set_bank_data_from_profile: '',
    },
    bank_account: {
        bank_accounts: 'Comptes bancaires',
        holder: 'Titulaire du compte',
        iban: 'IBAN',
        status: 'Statut',
        is_main: 'Compte principal',
        empty_state_header: 'Aucun compte bancaire',
        empty_state_description: 'Ajoutez un compte bancaire pour recevoir des paiements.',
        main_bank_account: 'Compte principal',
        set_as_main_bank_account: 'Définir comme principal',
        set_as_main_bank_account_success_message: 'Le compte bancaire a été défini comme compte principal.',
        in_progress: 'En cours',
        accepted: 'Accepté',
        rejected: 'Rejeté',
        expired: 'Expiré',
        bic: 'BIC',
        add_bank_account: 'Ajouter un compte bancaire',
        primary_bank_account: 'Compte bancaire principal',
        delete_confirm_title: 'Supprimer le compte bancaire ?',
        delete_confirm_message: 'Voulez-vous vraiment supprimer ce compte bancaire ? Cette action est irréversible.',
        delete_success_message: 'Le compte bancaire a été supprimé avec succès.',
        update_success_message: 'Le compte bancaire a été mis à jour avec succès.',
        create_success_message: 'Le compte bancaire a été ajouté avec succès.',
    },
    wallet: {
        vouchers: 'Vouchers',
        my_wallets: 'Mes portefeuilles',
        my_wallets_subtitle: 'Aperçu de mes portefeuilles',
        my_wallets_lemonway_note:
            'Actuellement, des restrictions peuvent affecter les retraits de votre portefeuille. Nous travaillons activement sur une solution et vous tiendrons informé.',
        deposit: 'Dépôt',
        withdraw: 'Retrait',
        secupay: 'Secupay',
        secupay_amount_info_text: 'Fournisseur de paiement uniquement, \n Aucun solde à afficher',
        lemonway: 'Lemonway',
        type: 'Type de portefeuille',
        no_transactions: 'Aucune transaction trouvée',
        account_holder: '',
        payment_reference: '',
        payment_amount: '',
        accept_terms: '',
        accept_terms_link: '',
        my_wallet: '',
        my_wallet_subtitle: '',
        legal_wallet: '',
        legal_wallet_subtitle: '',
        no_wallet: '',
        no_wallet_description: '',
        current_balance: '',
        retrievable_balance: '',
        voucher_balance: '',
        withdrawal_button: '',
        withdrawal_header: '',
        withdrawal_description: '',
        verify_bank_account_alert_header: '',
        verify_bank_account_alert_description: '',
        verify_bank_account_alert_action_button: '',
        verify_wallet_alert_header: '',
        verify_wallet_alert_description: '',
        verify_wallet_alert_action_button: '',
        deposit_header: '',
        deposit_via_bank_transfer_header: '',
        deposit_via_bank_transfer_description: '',
        deposit_button: '',
        deposit_description: '',
        withdrawal_button_submit: '',
        deposit_button_submit: '',
        transaction_history: '',
        transaction_history_subtitle: '',
        transaction_history_export_button: '',
        transaction_date: '',
        transaction_title: '',
        transaction_payment_method: '',
        transaction_amount: '',
        edit_profile: '',
        withdrawal_pending_heading: '',
        withdrawal_amount: '',
        withdrawal_account_description: '',
        deposit_amount: '',
        confirm_withdrawal_title: '',
        confirm_withdrawal_description: '',
        cancel_wallet_withdrawal_confirm_heading: '',
        cancel_wallet_withdrawal_confirm_description: '',
        cancel_wallet_withdrawal: '',
        cancel_wallet_withdrawal_success: '',
        cancel_wallet_withdrawal_error: '',
        withdrawal_bank_account: '',
        withdrawal_bank_account_select: '',
        payment_options: {
            bank_transfer: '',
            credit_card: '',
        },
        lw_trasaction_type: {
            0: '',
            1: '',
            2: '',
        },
        lw_trasaction_method: {
            0: '',
            1: '',
            4: '',
            3: '',
            13: '',
            14: '',
            15: '',
            16: '',
            17: '',
            18: '',
            19: '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: '',
        },
        dialogs: {
            money_withdrawal_verification_expired_link_title: '',
            money_withdrawal_verification_expired_link_message: '',
            money_withdrawal_verification_withdrawal_expired_title: 'Retrait expiré',
            money_withdrawal_verification_withdrawal_expired_message:
                'Le retrait a expiré. Veuillez lancer un nouveau retrait.',
            money_withdrawal_verification_no_longer_pending_title: '',
            money_withdrawal_verification_no_longer_pending_message: '',
            money_withdrawal_verification_success_title: '',
            money_withdrawal_verification_success_message: '',
            money_deposit_successful_title: '',
            money_deposit_successful_description: '',
            money_deposit_canceled_title: '',
            money_deposit_canceled_description: '',
            money_deposit_error_title: '',
            money_deposit_error_description: '',
            success_button: '',
            failure_button: '',
        },
    },
    voucher: {
        balance: '',
    },
    table: {
        pagination_results_overview: '',
        next: '',
        previous: '',
    },
    pending_investment_process: {
        title: '',
        description: '',
        resume_button: '',
        cancel_button: '',
    },
    texts: {
        email_change_notice: '',
        required: '',
        required2: '',
    },
    widget: {
        save: 'Save + Next',
        back: 'Back',
        sign_up_as: 'I am signing up as',
        natural_person: 'Natural Person',
        legal_entity: 'Legal Entity',
        step_counter: 'Step {currentStep} of {totalSteps}',
        close: 'Cancel',
    },
    esac_widget_sidebar: {
        // prettier-ignore
        natural_legal_select:
            '<p>Welcome to the KYC Wizard for the Investment Platform of the European Superangels Club. Once you have completed the KYC process (including uploading of supporting documentation and approval by Venionaire Ventures), you can access all investments on this platform, and also invest in opportunities. </p>' +
            '<p>If you have questions about the KYC process, or require assistance, please contact our support team at <a href="mailto:platform{\'@\'}superangels.club">platform{\'@\'}superangels.club</a>. </p>' +
            '<p>This process will take about 5 minutes for Natural Persons and 10-15 minutes for Legal Entities. </p>' +
            '<p>You will need the following information ready:</p>' +
            '<p><strong>Natural Person:</strong><br>' +
            '<ul><li>Tax information</li></ul></p>' +
            '<p><strong>Legal Entity:</strong> <br>' +
            '<ul><li>Tax information</li>' +
            '<li>CRS and FATCA classifications</li>' +
            '<li>Investment experience of second authorised signatory (if applicable)</li></ul></p>',
        natural_personal_data: 'Please complete your personal details.',
        natural_address_data:
            'Please provide your residential and postal address (if different). The residential address needs to correspond with your proof of address that you will upload later in the KYC process.',
        natural_investment_targets:
            'For you as an investor, it is important that we get to know your general attitude towards the type of investment, your risk-disposition, risk-bearing capacity, and risk knowledge. We therefore ask you to truthfully complete this form.',
        financial_conditions:
            'Please complete the information on your financial position. We are required to understand your risk-bearing capacity in relation to your approximate net financial wealth.',
        natural_experience_and_knowledge:
            'Please confirm your knowledge of and your practical investment experience in the instruments listed.',
        natural_fatca: 'Please confirm your FATCA status.',
        natural_tax: 'Please confirm your tax situation, and the countries of which you are a tax resident.',
        acknowledgements:
            'Please carefully read and confirm the statements provided. These will be electronically signed on the KYC forms.',
        natural_kyc_form:
            'Congratulations on completing the KYC wizard!\n' +
            ' This Form "Investor Questionnaire" includes all the information and acknowledgements you have just given. Please carefully review the form and sign it electronically. \n' +
            'You will also need to upload supporting documentation.\n' +
            'The form and documentation will then be reviewed by Venionaire Ventures, and once approved, you will be notified and can access all Investment Opportunities on this platform. We will contact you if we have any question.<br><br>' +
            'If an electronic signature is not possible, please print out the contract, sign the hard copy, and send it to:<br><br>' +
            'Venionaire Capital AG<br>' +
            'Babenbergerstraße 9/12<br>' +
            'A-1010 Vienna, Austria (EU)',
        legal_company_information:
            'Please supply registration information on the investing entity (hereinafter the "Investor" or "Entity"). \n' +
            'Please note that in this wizard Managing Directors ("MD") are defined as the authorised signatories of the Investor; Ultimate Beneficial Owners ("UBO") own or control an interest in the Investor (legal entity). \n' +
            'Please add any UBO who owns 20% or more of the share capital and/or voting rights as well as all MDs that are required to duly represent the Investor and decide on a potential investment.',
        legal_address_information: 'Please enter the registered address of the investing entity.',
        legal_manager_one_personal: 'Please complete your personal information and select the type of control.',
        legal_manager_two_personal:
            'Please complete the Personal Information of the respective MD or UBO and select the type of control.',
        legal_managers_ubo_overview:
            'Please add a potential co-Managing Director (joint representation of the investing Legal Entity), as well as other beneficial owners (ownership > 20%) of the investing Legal Entity (if applicable).',
        legal_manager_one_address: 'Please complete your address.',
        legal_manager_two_address: 'Please complete the residential address of the respective MD or UBO.',
        legal_manager_one_tax: 'Please complete your tax and ownership information',
        legal_manager_two_tax: 'Please complete the tax and ownership information of the respective MD or UBO.',
        // prettier-ignore
        legal_entity_investment_profile:
            'Il est important que nous connaissions l\'attitude générale de l\'investisseur vis-à-vis du type d\'investissement, sa disposition au risque, sa capacité à supporter le risque et sa connaissance du risque. Nous vous demandons donc de compléter honnêtement cette section pour l\'investisseur.',
        legal_entity_financial_position:
            /* eslint-disable-next-line quotes */
            "Veuillez compléter ces informations sur la situation financière de l'entité. Cela permet de comprendre la capacité de l'entité à supporter le risque par rapport à sa richesse financière nette approximative.",
        legal_manager_one_experience_and_knowledge:
            /* eslint-disable-next-line quotes */
            "Veuillez indiquer votre expérience personnelle et votre connaissance des classes d'actifs indiquées, ainsi que des marchés financiers. Veuillez compléter cela personnellement en tant que DG (et non pour l'entité juridique investisseuse).",
        legal_manager_two_experience_and_knowledge:
            /* eslint-disable-next-line quotes */
            "Veuillez indiquer l'expérience personnelle et la connaissance du DG 2 des classes d'actifs indiquées, ainsi que des marchés financiers.",
        legal_manager_two_authorization:
            /* eslint-disable-next-line quotes */
            "Veuillez compléter l'expérience d'investissement et les connaissances du DG 2, avec son approbation. Cela sera inclus dans un formulaire KYC qui sera signé par les deux dirigeants.",
        legal_entity_fatca:
            'Les informations de cette section sont destinées aux fins de la FATCA. Veuillez noter que cette classification peut différer de votre classification CRS.',
        legal_entity_tax_situation:
            /* eslint-disable-next-line quotes */
            "Veuillez confirmer la situation fiscale de l'entité et les pays dont elle est résidente fiscale.",
        legal_entity_crs:
            /* eslint-disable-next-line quotes */
            "Veuillez sélectionner la classification CRS de l'entité :",
        legal_acknowledgements:
            'Veuillez lire attentivement et confirmer les déclarations fournies. Celles-ci seront signées électroniquement sur les formulaires KYC.',
        legal_beneficial_owner: 'Veuillez compléter les informations personnelles du bénéficiaire effectif concerné.',
        legal_kyc_form:
            /* eslint-disable-next-line quotes */
            "Merci d'avoir complété l'assistant KYC ! Le formulaire 'ESAC entité juridique' comprend toutes les informations et les reconnaissances que vous venez de fournir. Veuillez examiner attentivement le formulaire et le signer électroniquement. Si vous avez un second signataire requis (DG 2), il/elle doit également signer ce formulaire. Le(s) document(s) partiellement prérempli(s) 'ESAC Legal UBO pour ...' doit/doivent être complété(s) et signé(s) par le(s) bénéficiaire(s) effectif(s) concerné(s). Le(s) document(s) complété(s) et signé(s) doit/doivent être téléchargé(s) sur la page du compte entreprise de la plateforme (sélectionnez votre profil dans le coin supérieur droit, puis compte entreprise, et Signatures en bas à gauche). \n" +
            'Les formulaires et la documentation seront ensuite examinés par Venionaire Ventures, et une fois approuvés, vous en serez informé et pourrez accéder à tous les investissements sur la plateforme. Nous vous contacterons si nous avons des questions sur votre formulaire ou vos documents.',
    },
    security: {
        password: {
            title: '',
            hint: '',
            update: '',
        },
        two_factor_authentication: {
            title: '',
            hint: '',
            configure: '',
            list_title: '',
            type: '',
            types: {
                otp: '',
                sms: '',
                passkey: '',
            },
            user_label: '',
            date: '',
            action: '',
            remove: '',
            non_removeable: '',
            remove_success: '',
        },
        dialogs: {
            error_title: '',
            error_message: '',
            success_title: '',
            success_message: '',
        },
        external_security_link: {
            title: '',
            hint: '',
            redirect: '',
        },
    },
    dialog: {
        button: {
            confirm: '',
            cancel: '',
            back: '',
            close: '',
            ok: '',
        },
        formDirty: {
            title: '',
            text: '',
            confirm: '',
            cancel: '',
        },
        formInvalid: {
            title: '',
            text: '',
        },
        iframe_link_notice: '',
        iframe_link_notice_link: '',
    },
    yes_no_deny: {
        yes: '',
        no: '',
        no_answer: '',
    },
}
